const initialize = require('./initialize')
const config = require('../login-config.json')

initialize(config)
